import { Navigate, Route, Routes } from "react-router-dom";

import RecoverPwsOtp from "../views/RecoverPws/RecoverPwsOtp/RecoverPwsOtp";
import CompleteRegister from "../views/CompleteRegister/CompleteRegister";
import ValidateIdentity from "../views/ValidateIdentity/ValidateIdentity";
import LoginSuccess from "../views/Login/LoginSuccess/LoginSuccess";
import PersonalData from "../views/PersonalData/PersonalData";
import RecoverPws from "../views/RecoverPws/RecoverPws";
import LastSteps from "../views/LastSteps/LastSteps";
import Navbar from "../components/Navbar/Navbar";
import Landing from "../views/Landing/Landing";
import Login from "../views/Login/Login";

const LOGIN_SUCCESS = (
	window.env.REACT_APP_LOGIN_URL || "/login-success"
).split("?")[0];

const Router = () => {
	return (
		<Routes>
			<Route path="/" element={<Landing />} />
			<Route path="/login" element={<Login />}></Route>
			<Route path="/forgot-pws" element={<RecoverPws />}></Route>
			<Route path="/forgot-pws-otp" element={<RecoverPwsOtp />}></Route>
			<Route
				path="/complete-register"
				element={<CompleteRegister />}
			></Route>
			<Route path={LOGIN_SUCCESS} element={<LoginSuccess />} />
            <Route path="/register" element={<Navbar />}>
				<Route index element={<Navigate to="/register/validate-identity" replace />} />
				<Route path="validate-identity" element={<ValidateIdentity />} />
                <Route path="personal-data" element={<PersonalData />} />
                <Route path="last-steps" element={<LastSteps />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
	);
};

export default Router;
